import LeftIcon from '@mui/icons-material/ChevronLeft';
import RightIcon from '@mui/icons-material/ChevronRight';
import { Fab, Stack, StackProps, Tooltip } from '@mui/material';

interface Props extends StackProps {
  currentPage: number;
  maxPage: number;
  onPreviousClick: () => void;
  onNextClick: () => void;
}

export const TablePagination: React.FC<Props> = ({
  currentPage,
  maxPage,
  onNextClick,
  onPreviousClick,
  ...props
}) => {
  return (
    <Stack direction="row" mt={2} justifyContent="flex-end" {...props}>
      <Tooltip title="Página anterior">
        <span>
          <Fab
            color="primary"
            size="small"
            aria-label="remove"
            disabled={currentPage <= 1}
            onClick={onPreviousClick}
            sx={{ zIndex: 0 }}
          >
            <LeftIcon />
          </Fab>
        </span>
      </Tooltip>

      <Fab disabled size="small" sx={{ mx: 1, zIndex: 0 }}>
        {currentPage}
      </Fab>

      <Tooltip title="Próxima página">
        <span>
          <Fab
            color="primary"
            size="small"
            aria-label="add"
            disabled={currentPage === maxPage}
            onClick={onNextClick}
            sx={{
              zIndex: 0,
            }}
          >
            <RightIcon />
          </Fab>
        </span>
      </Tooltip>
    </Stack>
  );
};
